<template>
  <section class="FooterZx">
    <div class="w1400">
      <h1 class="wow fadeInUp" data-wow-delay=".1s">{{ $t('pages.news.consultTitle') }}</h1>
      <p class="p wow fadeInUp" data-wow-delay=".2s">{{ $t('pages.news.consultDesc') }}</p>
      <a href="javascript:void(0);" class="zxbtn orangebtn wow fadeInUp" data-wow-delay=".3s" @click="show">{{ $t('pages.news.consultNow') }}</a>
    </div>
  </section>
</template>

<script>
import { useConsultPopup } from '@/composables/useConsultPopup';

export default {
  name: 'FooterZx',
  setup() {
    const { show } = useConsultPopup();
    return { show };
  }
};
</script>

<style scoped>
</style>
